<template>
    <div v-if="vehicle_stock_info && vehicle_stock_info.sold && vehicle_stock_info.sold.json && vehicle_stock_info.sold.json.unshipped && $userIsSuperAdmin()"
       title="Inspection">
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered inspection-table-nichibo">
                    <tr><td class="label">Stock#</td><td>{{showInspectionValue('stock_no')}}</td></tr>
                    <tr><td class="label">Reference#</td><td>{{showInspectionValue('reference_no')}}</td></tr>
                    <tr><td class="label">Vessel</td><td><span v-html="showInspectionValue('vessel')"></span></td></tr>
                    <tr><td class="label">KM</td><td><span v-html="showInspectionValue('km')"></span></td></tr>
                    <tr><td class="label">Grade</td><td>{{showInspectionValue('grade')}}</td></tr>
                    <tr><td class="label">Color</td><td>{{showInspectionValue('colour')}}</td></tr>
                    <tr><td class="label">Engine</td><td>{{showInspectionValue('engine')}}</td></tr>
                    <tr><td class="label">Chassis</td><td>{{showInspectionValue('chassis')}}</td></tr>
                    <tr><td class="label">Transmission</td><td></td></tr>
                    <tr><td class="label">Equipment</td><td>{{showInspectionValue('km')}}</td></tr>
                </table>
            </div>
            <div class="col-md-6">
                <table class="table table-bordered inspection-table-nichibo">
                    <tr><td class="label">Price</td><td>¥{{numberWithCommas(showInspectionValue('fob_jpy'))}}</td></tr>
                    <tr><td class="label">Shipped From</td><td>{{showInspectionValue('shipped_from')}}</td></tr>
                    <tr><td class="label">Destination</td><td>{{showInspectionValue('destination')}}</td></tr>
                    <tr><td class="label">Vessel</td><td><h3 v-html="showInspectionValue('vessel')"></h3></td></tr>
                    <tr><td class="label">Scheduled Departure</td><td>{{showInspectionValue('scheduled_departure')}}</td></tr>
                </table>
            </div>
        </div>
        <table class="table table-bordered inspection-table-nichibo">
            <tr><th colspan="4">Comments</th></tr>
            <tr><td class="label">Notes</td><td>{{comments.comments}}</td></tr>
            <tr><td class="label">Options</td><td>{{comments.options}}</td></tr>
            <tr><td class="label">Condition</td><td>{{comments.condition}}</td></tr>
            <tr><td class="label">Accessories</td><td>{{showInspectionValue('accessories')}}</td></tr>
        </table>
        <table class="table table-bordered inspection-table-nichibo width-25">
            <tr><th colspan="4">Options</th></tr>
            <tr>
                <td class="label">Fuel</td><td><span v-html="showInspectionValue('fuel')"></span></td>
                <td class="label">Stability Control</td><td><span v-html="showInspectionValue('stability_control', true)"></span></td>
            </tr>
            <tr>
                <td class="label">Cambelt or Chain</td><td><span v-html="showInspectionValue('belt_or_chain')"></span></td>
                <td class="label">Trim Colour</td><td><span v-html="showInspectionValue('trim_colour')"></span></td>
            </tr>
            <tr>
                <td class="label">Stereo</td><td><span v-html="showInspectionValue('stereo')"></span></td>
                <td class="label">Drive Type</td><td><span v-html="showInspectionValue('drive')"></span></td>
            </tr>
            <tr>
                <td class="label">Transmission</td><td><span v-html="showInspectionValue('shift')"></span></td>
                <td class="label">RIMS</td><td><span v-html="showInspectionValue('rims')"></span></td>
            </tr>
            <tr>
                <td class="label">Trim Material</td><td><span v-html="showInspectionValue('trim_material')"></span></td>
                <td class="label">Trim Colour</td><td><span v-html="showInspectionValue('trim_colour')"></span></td>
            </tr>
            <tr>
                <td class="label">No. Airbags</td><td><span v-html="showInspectionValue('air_bag_number')"></span></td>
                <td class="label">Cruise Control</td><td><span v-html="showInspectionValue('cruise_control', true)"></span></td>
            </tr>
            <tr>
                <td class="label">
                    Camera
                </td>
                <td>
                    <template v-if="valueTruthy('camera_none') === true">None</template>
                    <template v-else>
                        <template v-if="valueTruthy('camera_rear') === true">Rear</template>
                        <template v-if="valueTruthy('camera_front') === true">Front</template>
                        <template v-if="valueTruthy('camera_side') === true">Side</template>
                    </template>
                </td>
                <td class="label">Factory Suspension</td><td><span v-html="showInspectionValue('factory_suspension', true)"></span></td>
            </tr>
        </table>
        <table class="table table-bordered inspection-table-nichibo width-25">
            <tr><th colspan="4">Exterior Condition</th></tr>
            <tr>
                <td class="label">Total Panels Damaged</td><td><span v-html="showInspectionValue('total_damage_panels')"></span></td>
                <td class="label">Tyre Treat Front</td><td><span v-html="showInspectionValue('tyre_tread_front')"></span>mm</td>
            </tr>
            <tr>
                <td class="label">Total on Bumper Corners Damaged</td><td><span v-html="showInspectionValue('total_damage_bumper_corners')"></span></td>
                <td class="label">Tyre Treat Rear</td><td><span v-html="showInspectionValue('tyre_tread_rear')"></span>mm</td>
            </tr>
            <tr>
                <td class="label">Underbody</td><td><span v-html="showInspectionValue('underbody')"></span></td>
                <td>&nbsp;</td><td>&nbsp;</td>
            </tr>
        </table>
        <table class="table table-bordered inspection-table-nichibo width-25">
            <tr><th colspan="4">Interior</th></tr>
            <tr>
                <td class="label">Cigarette Burn</td>
                <td>
                    <template v-if="valueTruthy('no_cigarette_burn') === true">None</template>
                    <template v-else>
                        <template v-if="valueTruthy('cigarette_burn_hole') === true">Hole</template>
                        <template v-if="valueTruthy('cigarette_surface_burn') === true">Surface</template>
                        <template v-if="valueTruthy('cigarette_burn_seat') === true">Seat</template>
                        <template v-if="valueTruthy('cigarette_burn_door_trim') === true">Trim</template>
                        <template v-if="valueTruthy('cigarette_burn_roof_lining') === true">Roof-Lining</template>
                        <template v-if="valueTruthy('cigarette_burn_floor_mat') === true">Mat</template>
                    </template>
                </td>
                <td class="label">Smell</td><td><span v-html="showInspectionValue('smell')"></span></td>
            </tr>
            <tr>
                <td class="label">Dirt</td><td><span v-html="showInspectionValue('dirt')"></span></td>
                <td class="label">Dash Board Damage</td>
                <td>
                    <template v-if="valueTruthy('dash_board_no_damage') === true">No Damage</template>
                    <template v-else>
                        <template v-if="valueTruthy('dash_board_crack') === true">Dashboard-Crack</template>
                        <template v-if="valueTruthy('dash_board_glue_navi_stuck') === true">Glue-Navi-Stuck</template>
                    </template>
                </td>
            </tr>
            <tr>
                <td class="label">Dash Board Scratch</td><td><span v-html="showInspectionValue('smell')"></span></td>
                <td></td><td></td>
            </tr>
        </table>
        <table class="table table-bordered inspection-table-nichibo width-25">
            <tr><th colspan="4">Instruments and Controls</th></tr>
            <tr>
                <td class="label">Side Mirror</td>
                <td>
                    <template v-if="showInspectionValue('side_mirror_no_damage') === true">No Damage</template>
                    <template v-else>
                        <template v-if="valueTruthy('side_mirror_crack') === true">
                            Crack {{showInspectionValue('side_mirror_crack_type')}}
                        </template>
                    </template>
                </td>
                <td class="label">Power Window</td>
                <td>
                    <template v-if="showInspectionValue('power_window_working') === 'Power Window Works'">Power Window Works</template>
                    <template v-else>
                        <template v-if="valueTruthy('power_window_right_front_not_working') === true">Right-front-not-working</template>
                        <template v-if="valueTruthy('power_window_left_front_not_working') === true">Left-front-not-working</template>
                        <template v-if="valueTruthy('power_window_right_rear_not_working') === true">Right-rear-not-working</template>
                        <template v-if="valueTruthy('power_window_left_rear_not_working') === true">Left-rear-not-working</template>
                    </template>
                </td>
            </tr>
            <tr>
                <td>Front Window Screen</td>
                <td>
                    <template v-if="valueTruthy('front_window_screen_no_damage') === true">No Damage</template>
                    <template v-else>
                        <template v-if="valueTruthy('front_window_screen_stone_chip') === true">Stone-chip</template>
                        <template v-if="valueTruthy('front_window_screen_crack') === true">Crack</template>
                    </template>
                </td>
            </tr>
        </table>
        <table class="table table-bordered inspection-table-nichibo width-25">
            <tr><th colspan="4">Other</th></tr>
            <tr v-html="showInspectionRows(['tv', 'rear_percel_blind', 'head_rest', 'head_rest_seat_missing',
            'suspension_adjustable', 'suspension_aftermarket_spring', 'suspension_aftermarket_shock',
            'power_slide_door', 'van_doors', 'van_floor', 'scratches_panels', 'scratches_bumper_corners',
            'scratch_and_dent_comment', 'dents_panels', 'dents_bumper_corners', 'snow_tyres', 'cracked_tyres',
            'smoking_or_not', 'interior_comment',])"></tr>
        </table>
    </div>
</template>
<script>
    import {objLookup, numberWithCommas} from '../../util/common'

    export default {
        props: [
            'vehicle_stock_info',
            'show_image'
        ],
        data() {
            return {
            }
        },
        computed: {
            soldData(){
                if (this.vehicleStockData && this.vehicleStockData.sold && this.vehicleStockData.sold.json) {
                    return this.vehicleStockData.sold.json;
                }
                return {}
            },
            comments(){
                const return_value = {
                    comments: '',
                    options: '',
                    condition: '',
                }
                const notes = this.showInspectionValue('notes')
                if (notes) {
                    const regex = new RegExp(/General Comments:(.*)Options:(.*)Condition:(.+)/);
                    const res = regex.exec(notes)
                    if (res && res.length === 4) {
                        return_value.comments = res[1]
                        return_value.options = res[2]
                        return_value.condition = res[3]
                    }
                    console.log('regex', res)
                }
                return return_value;
            },
        },
        methods: {
            numberWithCommas,
            showInspectionValue(key, bool = false, invert_bool = false) {
                let value = objLookup(this.vehicle_stock_info, `sold.json.unshipped.${key}`)
                if (typeof value === 'undefined') {
                    return ''
                }
                if (Array.isArray(value) && !value.length) {
                    return ''
                }
                if (bool) {
                    let is_true = this.valueTruthy(key)
                    if (invert_bool) {
                        is_true = is_true ? false : false
                    }
                    let icon = is_true ? 'fa-check text-success' : 'fa-times text-danger'
                    return `<i class="fa ${icon}"></i>`
                }
                return value
            },
            showInspectionRows(rows){
                let html = ''
                let i = 0
                rows.forEach(key => {
                    let value = objLookup(this.vehicle_stock_info, `sold.json.unshipped.${key}`)
                    if (typeof value !== 'undefined' && (Array.isArray(value) && value.length)) {
                        i++
                        if (i % 2 === 0) {
                            html += '</tr><tr>'
                        }
                        let label = key.replace('_', ' ')
                        html += `<td>${label}</td><td>${value}</td>`
                    }
                })
                return html
            },
            valueTruthy(key) {
                let value = objLookup(this.vehicle_stock_info, `sold.json.unshipped.${key}`)
                if (Array.isArray(value) && !value.length) {
                    return null
                }
                if (typeof value === 'undefined') {
                    return null
                }
                if (['YES', 'yes', 1, '1'].includes(value)) {
                    return true
                }
                return false
            },
            formatNumber(val) {
                return numberWithCommas(val);
            },
        }
    }
</script>

<style scoped lang="scss">

@import "./resources/sass/mixins";
@import "./resources/sass/variables";

.inspection-table-nichibo{
    &.width-25{
        td{
            width: 25%;
        }
    }
    td{
        border: none;
        &.label{
            font-weight: bold;
        }
    }
    th{
        background-color: #ccc;
    }
    ul{
        list-style-type: disc;
        li{
            float: left;
            margin-left: 10px;
            margin-top: 0;
            padding: 0 25px 0 0px;
            &:nth-child(1) {
                list-style-type: none;
            }
            &::before,&::after{
                display: none;
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/NichiboInspection.vue